export default {
  plan: 'План',
  continue: 'Продовжити',
  docs: 'Документація',
  assistViaEmail: 'Ми будемо раді допомогти вам електронною поштою.',
  sendFeedback: 'Будь ласка, надсилайте свої запитання та відгуки на',
  howDoISignUp: 'Як зареєструватися',
  requiredName: "Ім'я є обов'язковим полем",
  requiredEmail: 'Електронна адреса є обов’язковим полем',
  requiredPassword: 'Пароль є обов’язковим полем',
  invalidEmail: 'Некоректна електронна адреса',
  minLengthPassword: 'Пароль має містити щонайменше 8 символів або цифр',
  invalidPassword:
    'Пароль має містити одну велику літеру, одну малу літеру, одну цифру та один спеціальний символ',
  getStartedWorkoutPlanEmailReminder:
    'Щоб розпочати, просто перейдіть на вебсторінку Fit4me та дайте відповіді на кілька коротких запитань про ваші вподобання щодо тренувань і харчування, цілі та загальний рівень фізичної підготовки. Ми також попросимо вашу електронну адресу: будь ласка, переконайтеся, що ви ввели її правильно. Після цього ми створимо план, спеціально розроблений для вас, і надамо посилання для завантаження додатку, щоб ви могли розпочати одразу.',
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    'Як я отримаю свій персоналізований план харчування та тренувань',
  appDownloadAndAccessInstructions:
    'Ви отримаєте унікальне посилання для завантаження, яке перенаправить вас до AppStore для завантаження додатку. Після встановлення додатку на ваш телефон, вам потрібно буде увійти, використовуючи свою електронну адресу. Ви матимете необмежений доступ до всіх функцій додатку протягом оплаченого періоду. Якщо у вас виникнуть труднощі із завантаженням або доступом до додатку, будь ласка, зверніться до нас за адресою',
  planReceiveTime: 'Коли я отримаю свій персоналізований план харчування та тренувань',
  planGenerationDetails:
    'Наші розумні алгоритми є надзвичайно точними та дозволяють персоналізувати ваш фітнес-план відповідно до ваших конкретних потреб. Унікальне посилання для завантаження буде згенеровано одразу після оплати. План стане доступним одразу після завантаження додатку за цим посиланням.',
  freeTrialQuestion: 'Чи ми завжди пропонуємо безкоштовний пробний період',
  freeTrialInfo:
    'Зверніть увагу, що якщо надається безкоштовний пробний період, це буде чітко зазначено на екрані з цінами перед оформленням підписки. Якщо цього немає, ви купуєте підписку без пробного періоду.',
  billingQuestion: 'Як буде здійснюватися оплата',
  billingInfo:
    'Зазвичай ми пропонуємо підписки, які автоматично поновлюються. Залежно від обраного варіанту, ваша підписка буде автоматично поновлена в кінці кожного періоду.',
  cancelSubscriptionQuestion: 'Чи можу я скасувати підписку',
  cancelSubscriptionInfo:
    'Ваша підписка автоматично поновлюється в кінці кожного періоду, поки ви її не скасуєте. Зверніть увагу, що видалення додатку не скасовує підписку. Ви можете скасувати пробний період або підписку через налаштування підписок на вашому iPhone або електронною поштою.',
  noAccessQuestion: 'Я більше не маю доступу до своєї підписки. Що сталося?',
  noAccessInfo:
    'Іноді ми пропонуємо підписки, що не поновлюються, які припиняються після закінчення періоду (1 місяць, 3 місяці або 6 місяців). Після завершення терміну вашої підписки доступ до додатку буде припинено. Якщо ви хочете продовжити користування додатком після завершення первинної підписки, ви можете повторно придбати її у додатку або на сайті Fit4me у будь-який час.',
  loginLabel:
    'Увійдіть за допомогою електронної пошти, щоб отримати доступ до свого персонального плану схуднення',
  email: 'Електронна адреса',
  logIn: 'Увійти',
  name: 'Ім’я',
  gender: {
    label: 'Стать',
    male: 'чоловіча',
    female: 'жіноча',
  },
  dateOfBirth: 'Дата народження',
  units: {
    label: 'Одиниці виміру',
    kg: 'кг',
    cm: 'см',
    lbs: 'фнт',
    in: 'дм',
    m: 'м',
    ft: 'фут',
  },
  startWeight: 'Початкова вага',
  height: 'Висота',
  doubleCheckAndRetry: 'Будь ласка, перевірте ще раз і спробуйте знову',
  wrongEmail: 'Ой, неправильна електронна адреса',
  invalidEmailOrPassword: 'Ой, неправильна електронна адреса або пароль',
  avatar: 'avatar',
  Profile: 'Профіль',
  Subscriptions: 'Підписки',
  loader: 'loader',
  billingPeriod: 'Платіжний період',
  subscriptionPrice: 'Вартість підписки',
  subscriptionCanceled: 'Вашу підписку скасовано.',
  noFutureCharges: 'У майбутньому списань не буде.',
  fullAccessUntilExpires: 'Ви матимете повний доступ до Fit4Me до завершення поточної підписки.',
  opps: 'Ой! <br/>Щось пішло не так.',
  contactUsEmail:
    'Звʼяжіться з нами через <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'ок',
  tooExpensive: 'Занадто дорого',
  planNotSuitable: 'План не відповідає моїм потребам',
  appQualityDisappointment: 'Якість додатку не відповідає моїм очікуванням',
  notUsingButMayReturn: 'Зараз я не використовую додаток, але готовий повернутися пізніше',
  goalsAchieved: 'Я вже досяг(ла) своїх цілей',
  technicalIssues: 'Були технічні проблеми',
  planTooChallenging: 'Мій персональний план занадто складний',
  avoidAutoRenewalFee: 'Я хочу уникнути автоматичного списання',
  forgotPassword: 'Забули пароль?',
  resetPassword: 'Скинути пароль',
  labelForgot: 'Введіть свою електронну адресу для скидання пароля',
  placeholderEmail: 'Введіть свою електронну адресу',
  recoveryEmailSentAt: 'Лист для відновлення надіслано о',
  pleaseCheckYourInbox: 'Перевірте свою поштову скриньку (та спам)',
  sendAgain: 'надіслати ще раз',
  changeEmail: 'змінити електронну адресу',
  checkingYouEmail: 'Перевіряємо вашу електронну пошту',
  agreePrivacyPolicy:
    'Продовжуючи, ви погоджуєтеся з нашою <privacy>Політикою конфіденційності</privacy> та <terms>Умовами використання</terms>',
  emailLogin: 'Вхід через електронну пошту',
  loginToFit4Me: 'Увійти до Fit4Me',
  enter5DigitCode:
    'Введіть 5-значний код, надісланий на вашу електронну адресу <bold>{{email}}</bold>',
  didNotReceiveTheCode: 'Не отримали код?',
  resendCode: 'Надіслати код повторно',
  contactSupport: 'Або ви можете <bold>звернутися в нашу підтримку</bold>',
  codeResent: 'Код повторно надіслано! Ви можете запросити інший через <bold>{{seconds}}с</bold>',
  emailDoesntMatch: 'Код для входу не збігається',
  reCheck: 'Перевірте код ще раз або запросіть новий.',
  payments: 'Платежі',
  manageSubscription: 'Керувати підпискою',
  activeBadge: 'Активна',
  paymentMethod: 'Спосіб оплати',
  cancelSubscriptionReason: 'Чому ви хочете скасувати?',
  nextChargeDate: 'Наступна дата списання',
  lastChargeDate: 'Остання дата списання',
  accessUntil: 'Доступ до',
  renewSubscription: 'Поновити підписку',
  addPaymentMethod: 'Додати спосіб оплати',
  noPaymentTitle: 'Немає способів оплати',
  noPaymentDescription: 'Додайте спосіб оплати, щоб розпочати користування підпискою',
  canceledStatus: 'Скасовано',
  yourFeedbackMatters: 'Ваша думка важлива!',
  specialOffer: 'Зачекайте, ми готуємо для вас спеціальну пропозицію.',
  limitedDeal: 'Обмежена пропозиція',
  offerSavings: 'Ми пропонуємо 99% знижки на 6 тижнів',
  keepWellness: 'Продовжуйте свою подорож до здоров’я лише за 1% від звичайної вартості!',
  dontMissChance:
    '{{name}}, не втратьте шанс продовжити з персоналізованими порадами з харчування від Simple. Після 3-місячного періоду економії автоматично відновлюється стандартна квартальна оплата (79,20 $).',
  keepPremium: 'Залишити Premium',
  cancelSubscriptionBtn: 'Скасувати підписку',
  footerText:
    'Пам’ятайте: ви можете скасувати будь-коли до 30 квітня 2025 року без жодних додаткових платежів. Ваша 99% знижка діє протягом усіх 12 тижнів. Якщо ви вирішите продовжити, після завершення акційного періоду ваша підписка автоматично поновиться за стандартною квартальною ціною 79,20 $. Ми не повертаємо кошти за частково використаний час підписки. Щоб керувати підпискою або скасувати її, просто відвідайте сторінку керування підпискою.',
  prosList: {
    analyzed: 'Ваш профіль проаналізовано',
    noChange: 'Жодних змін у вашому поточному циклі оплати',
    after: 'Після 12 тижнів підписка коштуватиме 79,20 $ щокварталу.',
  },
  gotIt: 'Добре, зрозуміло',
  weCanceled: 'Ми скасували вашу підписку',
  yourSubscriptionIsCanceled:
    'Ваша підписка Fit4Me скасована. Нові списання не будуть проводитися. Доступ зберігається до',
  supportForEditional: 'щоб отримати додаткову інформацію',
  contact: 'Звʼяжіться',
  id: 'ID',
  'My account': 'Мій акаунт',
  'My Subscriptions': 'Мої підписки',
  Support: 'Підтримка',
  FAQ: 'Поширені запитання',
  'Cancel Subscription': 'Скасувати підписку',
  'Money-Back Policy': 'Політика повернення коштів',
  'Privacy Policy': 'Політика конфіденційності',
  'Terms of Use': 'Умови використання',
  'Meals Recommendations': 'Рекомендації щодо харчування',
  'Contact Us': 'Звʼязатися з нами',
}
